import * as React from 'react'
import { ReactElement } from 'react'
import { DefaultButton, FontSizes, FontWeights, ImageCoverStyle, ImageFit, mergeStyles } from '@fluentui/react'
import { IButtonProps } from '@fluentui/react/lib/components/Button/Button.types'

type Props = Omit<IButtonProps, 'styles' | 'iconProps'> & {
    iconSize?: number
    iconSrc: string | undefined
}

// noinspection JSUnusedGlobalSymbols
export default function RibbonButton(props: Props): ReactElement {
    return (
        <DefaultButton
            styles={{
                root: mergeStyles({ height: 'auto', padding: 8, border: 'none' }),
                flexContainer: mergeStyles({ flexDirection: 'column', gap: 8 }),
                icon: { height: 'auto' },
                label: { fontSize: FontSizes.small, fontWeight: FontWeights.regular },
            }}
            iconProps={{
                imageProps: {
                    src: props.iconSrc,
                    width: props.iconSize || 32,
                    height: props.iconSize || 32,
                    imageFit: ImageFit.centerCover,
                    coverStyle: ImageCoverStyle.landscape,
                },
            }}
            {...props}
        />
    )
}
